import { TableData } from "src/modules/sm-base/models/table-data.model";
import { FrontendScriptFound } from "./frontend-script-found.model";
import { TableColumn, } from "src/modules/sm-base/models/table-column.model";
import { TableCellType } from "src/modules/sm-base/models/table-cell-type.enum";
import { TableSortColumn } from "src/modules/sm-base/models/table-sort-column.model";
import { TableRow } from "src/modules/sm-base/models/table-row.model";
import { FrontendScriptDefinition } from "./frontend-script-definition.model";
import { TableCell } from "src/modules/sm-base/models/table-cell.model";
import { Utils } from "src/modules/utils/shared/utils";

export class FrontendScriptSearchResult {
    title: string;
    found: FrontendScriptFound[] = [];
    guiTable: TableData;

    constructor(title: string) {
        this.title = title;
    }

    createTable(scripts: FrontendScriptDefinition[]): void {
        console.trace(this.found);
        let groups = Utils.arrayGetUnique(Utils.arrayExplode(this.found, f => f.groups != null ? Utils.getOwnPropertyNames(f.groups) : []));
        this.guiTable = new TableData([
            new TableColumn("script", "Skript", TableCellType.text, { autoWidth: 50 }),
            new TableColumn("lineNumber", "Zeile", TableCellType.int, { autoWidth: 4 }),
            new TableColumn("line", "Zeile", TableCellType.text, { flex: 1 }),
            ...groups.map(group => new TableColumn("group_" + group, group, TableCellType.text, { autoWidth: 20 }))
        ], this.found.map(f => new TableRow("", f, {
            script: new TableCell(scripts.find(s => s.id == f.scriptId).getFullName(), { styleClass: "monospace" }),
            lineNumber: new TableCell(f.lineNumber, { styleClass: "monospace" }),
            line: new TableCell(f.line, { keepHtml: true, styleClass: "monospace" }),
            ...Utils.arrayConvertToOrdinaryObject(groups, group => "group_" + group, group => new TableCell(f.groups[group] ?? "", { styleClass: "monospace" }))
        })), [ new TableSortColumn("script"), new TableSortColumn("lineNumber")]);
    }
}
